import Logger, { LOG_LEVELS } from "../utils/log";
import getClientConfig from "./getClientConfig";

const MODULE_NAME = "APP_CONFIG";
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

const {
  fullStoryOrgId,
  fullStoryDevMode,
  preparerApproverEnabled,
} = getClientConfig();

//TODO: Config should support multiple env and to be part of build automation process
/**
 * Section for settings depends on VAT Reporting Module configurations.
 */
export const ProcessedFileRedeliver = Object.freeze({
    PROCESSED_FILE_REDELIVER_POLL_INTERVAL: 30000,
    PROCESSED_FILE_REDELIVER_MESSAGE_INTERVAL: 10000,
});

export const VatReturnAsyncGeneration = Object.freeze({
    POLL_INTERVAL: 5000,
    MAX_POLL_DURATION: 60 * 1000, // 1 minute
    MAX_CONSECUTIVE_ERRORS: 3,
});
export const DateTimeConfig = Object.freeze({
    DEFAULT_DATE_FORMAT: "yyyy-mm-dd",
    DEFAULT_MOMENT_DATE_FORMAT: "YYYY-MM-DD",
});

export const UploadConfig = Object.freeze({
    /**
     * Maximum file size in KB
     */
    //TODO: Make this value configurable via env. variable @MAX_FILE_SIZE@
    maxFileSize: 153600,
    bytesPerKB: 1024,
    accountSettingsMaxUploadSizeInMB: 5,
});

export const ErrorsWarningsConfig = Object.freeze({
    MAX_PROCESSING_LIMIT: 1000,
    MAX_PROCESSING_MULTI_REQUEST_LIMIT: 100,
});

export const EnablePartnerViewQueryString = Object.freeze({
    QUERY_STRING: "enablePartnerView=true",
});

//TODO: This needs to be fetched from API
export const AuthConfig = Object.freeze({
    ROLES_FEATURES_CONFIG: [
        {
            role: "Admin",
            features: [
                "AccountSettings",
                "Companies",
                "CompanyPermissions",
                "DirectSubmissionPermissions",
                "UserManagement",
                "VATCodes",
                "VATCodeSimulator",
                "ExchangeRates",
                "VATGroups",
                "SettingsMenu",
                "LiveReportingSetup",
                "CountriesOnHold",
                "ApiLicenseKey",
            ]
        },
        {
            role: "Reporting User",
            features: [
                "VATCodeSimulator",
                "ExchangeRates",
            ]
        },
        {
            role: "Preparer",
            features: [
                "VATCodeSimulator",
            ]
        },
        {
            role: "ReadOnly",
            features: [
                "AccountSettings",
                "Companies",
                "VATCodes",
                "VATCodeSimulator",
                "ExchangeRates",
                "VATGroups",
                "SettingsMenu",
                "CountriesOnHold"
            ]
        }
    ],
});

export const TableConfig = Object.freeze({
    PAGINATION: {
        STANDARD_PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
        STANDARD_LEVEL_ONE_PAGE_SIZE: 20,
        STANDARD_LEVEL_TWO_PAGE_SIZE: 10,
        STANDARD_MIN_PAGE_SIZE: 10,
        STANDARD_MAX_PAGE_SIZE: 100,
        REPORT_PAGE_SIZE_OPTIONS: [500, 1000, 2000, 5000, 10000],
        REPORT_LEVEL_ONE_PAGE_SIZE: 500
    },
});

/**
 * Full Story config
 */
export const FullStoryConfig = Object.freeze({
    namespace: "FullStory",
    orgId: fullStoryOrgId,
    devMode: fullStoryDevMode,
});
log.debug("FullStoryConfig.devMode: ", FullStoryConfig.devMode);

/**
 * Feature flags
 */
 export const FeatureFlagConfig = Object.freeze({
    namespace: "FeatureFlag",
    // ENV vars can be booleans in deployed environments but strings locally, so we check both cases
    preparerApproverEnabled: preparerApproverEnabled,
});
log.debug("FeatureFlagConfig.devMode: ", FeatureFlagConfig.devMode);

/**
 * Main section to include sub-sections and app wide configurations.
 */
export const AppConfig = Object.freeze({
    ProcessedFileRedeliver: ProcessedFileRedeliver,
    VatReturnAsyncGeneration: VatReturnAsyncGeneration,
    UploadConfig: UploadConfig,
    DateTimeConfig: DateTimeConfig,
    ErrorsWarningsConfig: ErrorsWarningsConfig,
    TableConfig: TableConfig,
    AuthConfig: AuthConfig,
    FullStoryConfig: FullStoryConfig,
    EnablePartnerViewQueryString:EnablePartnerViewQueryString,
    FeatureFlagConfig: FeatureFlagConfig,
});

export default AppConfig;
